import React from "react";
import MDBox from "components/MDBox";
import FilterCard from "./components/filterCard";
import AlertTable from "./components/alertTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import AddAlertPopup from "./components/addAlertPopup";
import EditAlert from "./components/editAlert";
import DeletePopup from "./components/deletePopup";
import EditMultiple from "./components/editMultiple";
import AddMultyAlertDialog from "./components/addMultiple";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
function AlertConfiguration() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <FilterCard />
        <AlertTable />
        <AddAlertPopup />
        <EditAlert />
        <DeletePopup />
        <EditMultiple />
        <AddMultyAlertDialog />
      </MDBox>
    </DashboardLayout>
  );
}

export default AlertConfiguration;
